module.exports = __webpack_public_path__ + "static/media/migrant.bcb63d7a.png";